import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

export const projectKeys = {
  all: ['projects'],
  lists: () => [...projectKeys.all, 'list'],
  list: (filters) => [...projectKeys.lists(), filters],
  details: () => [...projectKeys.all, 'detail'],
  detail: (id) => [...projectKeys.details(), id],
};

// Fetch all projects for an organization
export function useProjects(orgId) {
  return useQuery({
    queryKey: projectKeys.list(orgId),
    queryFn: () => apiHelper.getResource('/org/projects/', { orgId }),
    enabled: !!orgId,
  });
}

// Fetch single project
export function useProject(id) {
  return useQuery({
    queryKey: projectKeys.detail(id),
    queryFn: () => apiHelper.getResource(`/org/projects/${id}/`),
    enabled: !!id,
  });
}

// Create project
export function useCreateProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (nestedData) => {
      const orgId = nestedData.project?.org;
      return apiHelper.postResource('/org/sys/projects/setup/', nestedData, { orgId });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: projectKeys.lists() });
    },
  });
}

// Update project
export function useUpdateProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data, orgId }) => {
      const options = orgId ? { orgId } : {};
      return apiHelper.putResource(`/org/projects/${id}/`, data, options);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: projectKeys.lists() });
    },
  });
}

// Delete project
export function useDeleteProject() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, orgId }) => {
      const options = orgId ? { orgId } : {};
      return apiHelper.deleteResource(`/org/projects/${id}/`, options);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: projectKeys.lists() });
    },
  });
}